// @ts-nocheck

/**
 * * `upload` - User Upload
 * `generated` - AI Generated
 * `library` - From Library
 */
export type SourceEnum = typeof SourceEnum[keyof typeof SourceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceEnum = {
  upload: "upload",
  generated: "generated",
  library: "library",
} as const;
